import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Box } from '@material-ui/core';
import notFound from 'assets/svgs/not-found.svg';
import MultiLineResponsiveText from './MultiLineResponsiveText';

function NoDataPage(props) {
	const { isSmallScreen } = props;

	return (
		<Grid container justifyContent="space-between">
			<Grid item xs={12} sm={12} md={12} lg={12}>
				<Box display="flex" justifyContent="center">
					<img
						style={{
							width: isSmallScreen ? '124px' : '154px',
							height: isSmallScreen ? '87px' : '109px'
						}}
						src={notFound}
						alt="Something went wrong"></img>
				</Box>
				<Box display="flex" justifyContent="center" mt={2} mx={5}>
					<MultiLineResponsiveText
						isSmallScreen={isSmallScreen}
						msg1={'No Results Found.'}
						msg2={'Try a different keyword.'}
					/>
				</Box>
			</Grid>
		</Grid>
	);
}

NoDataPage.propTypes = {
	isSmallScreen: PropTypes.bool,
	reload: PropTypes.func
};

export default NoDataPage;
